module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-children.2cad12e9.svg";